const Lang = require('lang');
const confirm = require('../events/confirm');
const GlobalAlerts = require('global_alerts');
const DetalhesLoteIntegracao = require('./DetalhesLoteIntegracao');
const ReimportacaoLotes = require('./ReimportacaoLotes');
const CambioLotes = require('./CambioLotes');

/**
 * Atualizar a tabela de exibição de dados de Lote
 * e de eventos referentes ao lote, este código é
 * reaproveitado para ambos
 */
function FiltrarLotesEventosIntegracao() {
  nifty.body.overlay({
    fixed: true
  });
  applyListenerFilter();
}

/**
 * Aplicar o Listener do botão
 * de pesquisar as despesas
 *
 * @return {void}
 */
function applyListenerFilter() {
  const buttonFilter = document.querySelectorAll('[data-button-filter-lotes]');
  if (buttonFilter.length) {
    buttonFilter.forEach((currentButton) => {
      currentButton.addEventListener('click', clickHandler);
    });
  }
}

/**
 * Inicializar o plugin do jquery ui date
 * nas inputs de data para os filtros de
 * lotes e logs
 *
 * @return {void}
 */
function initalizeInputsDate() {
  const inputsDate = document.querySelectorAll('[data-input="date"]');
  inputsDate.forEach((currentInput) => {
    $(currentInput).datepicker();
  });
}
/**
 * Adicionando o Event Listener
 *
 * @param  {event} event
 *
 * @return {void}
 */
function clickHandler(event) {
  const button = event.target;
  const idContainer = button.dataset.buttonFilterContainer;
  const resultContainer = document.querySelector(`#${idContainer}`);
  nifty.body.overlay('show');

  sendRequestFilter(event.currentTarget.form)
    .done(function(data) {
      resultContainer.innerHTML = data.data;
      DetalhesLoteIntegracao.applyListeners();
      ReimportacaoLotes.applyListeners();
      CambioLotes.applyListeners();
      initalizeInputsDate();
    })
    .fail(function(error) {
      GlobalAlerts.createAndShow({
        type: 'danger',
        message: error.responseJSON.data
      });
    })
    .always(function() {
      nifty.body.overlay('hide');
    })
}

/**
 * Enviar a request com a busca dos dados
 *
 * @param  {element} form
 *
 * @return {response}
 */
function sendRequestFilter(form) {
  return $.ajax({
    method: 'POST',
    url: form.action,
    data: $(form).serialize()
  });
}

module.exports = {
  init: FiltrarLotesEventosIntegracao,
  url: /^\/admin\/integracoes|^\/admin\/importacao/,
  initalizeInputsDate: initalizeInputsDate,
  applyListenerFilter: applyListenerFilter
};
